//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MattingLoading",
  props: {
    status: {
      type: String,
      default: "normal",
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    msg() {
      const msgMap = {
        error: this.$t("Matting.error"),
        loading: this.$t("Matting.loading"),
        success: "",
      };

      return msgMap[this.status];
    },
    isShow() {
      const list = ["error", "loading"];
      return list.includes(this.status);
    },
    isError() {
      return this.status === "error";
    },
  },
};
